import { Typography, Table, Tag, Col, Popover, Menu, Spin, Modal } from "antd";
import {
  Metrics,
  Helpers,
  Colors,
  Spacing,
  channelColors as colors,
  Fonts,
  Images,
  months,
} from "../../global";
import { Row, Icon, View, LoadingIcon, Graph } from "../../Components";
import { useEffect, useState, useRef } from "react";
import { useRecoilValue, useRecoilState } from "recoil";
import { useNavigate, useMatch, useLocation } from "react-router-dom";
import { allSitesAtom } from "../../Atoms/allSitesAtom";
import { useCookies } from "react-cookie";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { ReactComponent as optionsIcon } from "../../Assets/SVG/Options.svg";
import { ReactComponent as backIcon } from "../../Assets/SVG/Back.svg";
import { MdKeyboardArrowLeft } from "react-icons/md";
import {
  ToolTypes,
  getLiveGraphData,
  addGraphLiveData,
  updateToolSettings,
  getToolSettings,
  saveSession,
  exportFile,
  newSheet,
  clearAlert as clearAlertAPI,
  clearAlerts as clearAlertsAPI,
  deleteAlerts as deleteAlertsAPI,
  addAlert as addAlertAPI,
  updateAlert,
  getAlerts,
} from "../../API";
import {
  THP_ENABLED_ARRAY,
  THP_CHANNEL_ICONS,
  THP_DEFAULT_Y_AXIS,
  THP_CH_ENUM,
  THP_ENABLED_CHANNELS,
} from "../../Tools/THP";
import HelperService from "../../Helpers/HelperService";
import { ResponsiveLine } from "@nivo/line";
import { ReactComponent as startIcon } from "../../Assets/SVG/TimeStart_Small.svg";
import { ReactComponent as endIcon } from "../../Assets/SVG/TimeEnd_Small.svg";
import { ReactComponent as fileIcon } from "../../Assets/SVG/File.svg";
import { ReactComponent as leftIcon } from "../../Assets/SVG/Left.svg";
import { ReactComponent as rightIcon } from "../../Assets/SVG/Right.svg";
import { ReactComponent as sliderIcon } from "../../Assets/SVG/Slider.svg";
import { useGoogleLogin } from "@react-oauth/google";
import {
  Group,
  Paper,
  Button,
  Text,
  Space,
  Title,
  Divider,
  TextInput,
  NumberInput,
} from "@mantine/core";
import _ from "lodash";

const previewWidth = 400;
const previewHeight = 200;
const formatList = ["CSV", "Excel XLSX", "PDF"];
let defaultEn = [true, true, true, true, true, true];
let defaultEnAxis = [true, true, true, true, true, true];
let graphPropsDashboard = {
  enX: true,
  start: null,
  end: null,
  en: defaultEn,
  enY: defaultEnAxis,
  enYCount: 0,
  currZoom: { x: 0, scale: 1 },
  customScope: false,
};
const maxAttributes = 8;
let xdata = [];
let icons = THP_CHANNEL_ICONS;
let multiplier = (previewWidth - 20) / (xdata.length - 1);
let data = Array.from(Array(maxAttributes), () => new Array(0));
let yAxisEnabledCount = 0;
let tempUnits = Array.from(Array(maxAttributes), () => "");
let channels = new Array(maxAttributes);
let tempScopeAdjustment;
// let graphDataPulled = false
let tempData = [];
let TOOL_CH_ENUM = THP_CH_ENUM;
let attributeArray;
let verticalLines = [];
let channelNames = [];
let channelUnits = [];
let channelValues = [];
let enabledChannels;
let tempChannelSelector = {};
let lastWidth;
let lastHeight;
let lastEnabledAxis;
// let tool
let cloudUpperLimit;
let cloudLowerLimit;
let tempPositionX = undefined;
let tempPositionY = undefined;
let currSlider = 0; // 0=start 1=end
let min;
let max;
let moving = false;

function Sites() {
  const navigate = useNavigate();
  const [allSites, setAllSites] = useRecoilState(allSitesAtom);
  const location = useLocation();
  console.log("location:", location);
  const match = useMatch("/sensor/:mac");
  const matchEdit = useMatch("/sensor/:mac/edit");
  const mac = window?.location?.pathname.includes("edit")
    ? matchEdit?.params.mac
    : match?.params.mac;
  console.log("mac:", mac);
  console.log("Store All Sites:", allSites);
  const { user } = useAuthenticator((context) => [context.user]);
  let email = "";
  if (user?.attributes?.email) email = user?.attributes?.email;
  const [currentStore, setCurrentStore] = useState();
  const ref = useRef();
  let todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);
  let todayEnd = new Date();
  todayEnd.setHours(23, 59, 59, 999);
  const [tool, setTool] = useState();
  const [recipient, setRecipient] = useState(
    tool?.share_id ? allSites["recipientShares"][mac] : null
  );
  const [cookies, setCookie] = useCookies([email]);
  const { Title } = Typography;
  const [displayData, setDisplayData] = useState([]);
  const [displayDataZoomed, setDisplayDataZoomed] = useState([]);
  const [chartUpdated, setChartUpdated] = useState(true);
  const [graphData, setGraphData] = useState({
    startOfData: 1690394385,
    data_id_createdAt: 1690394385,
    totalRecordCount: 0,
    updatedAt: HelperService.getEpoch(new Date()),
    data: [],
    rawData: [],
    convertedData: [],
    normalData: [],
  });
  const [expandedSensor, setExpandedSensor] = useState([]);
  const [showGraphProps, setShowGraphProps] = useState(false);
  const [shareFile, setShareFile] = useState(false);
  const [enabled, setEnabled] = useState(
    graphPropsDashboard?.en
      ? graphPropsDashboard.en.map((attribute) => attribute)
      : defaultEn
  );
  const [xdataZoomed, setXdataZoomed] = useState(xdata);
  const [fullscreen, setFullscreen] = useState(false);
  const [startOfData, setStartOfData] = useState(graphData.startOfData);
  const [scope, setScope] = useState("custom");
  const [scopeAdjustment, setScopeAdjustment] = useState({
    live: 0,
    day: 0,
    week: 0,
    month: 0,
    all: 0,
    custom: 0,
  });
  const [startTime, setStartTime] = useState(
    displayDataZoomed[0]?.data != undefined &&
      displayDataZoomed[0]?.data.length > 0 &&
      displayDataZoomed[0]?.data[0]?.x != undefined
      ? displayDataZoomed[0]["data"][0]["x"]
      : undefined
  );
  const [customStartTime, setCustomStartTime] = useState(
    startTime
      ? startTime
      : new Date(todayStart.setDate(new Date().getDate() - 6))
  );
  const [stopTime, setStopTime] = useState(
    displayDataZoomed[0]?.data[displayDataZoomed[0]?.data.length - 1] !=
      undefined
      ? displayDataZoomed[0]["data"][displayDataZoomed[0]?.data.length - 1]["x"]
      : undefined
  );
  const [customStopTime, setCustomStopTime] = useState(
    stopTime ? stopTime : todayEnd
  );
  const [startDatePicker, setStartDatePicker] = useState(false);
  const [stopDatePicker, setStopDatePicker] = useState(false);
  const [enabledAxis, setEnabledAxis] = useState(graphPropsDashboard?.enY);
  const [height, setHeight] = useState(lastHeight);
  const [width, setWidth] = useState(lastWidth);
  const [loading, setLoading] = useState(true);
  const [upper, setUpper] = useState();
  const [lower, setLower] = useState();
  const [upperAlert, setUpperAlert] = useState();
  const [lowerAlert, setLowerAlert] = useState();
  const [saveLoading, setSaveLoading] = useState(false);
  const [format, setFormat] = useState(0);
  const [exportLoading, setExportLoading] = useState(false);
  const [exportInitiated, setExportInitiated] = useState(false);
  const [sheetLoading, setSheetLoading] = useState(false);
  if (tempPositionX == undefined) tempPositionX = 0; // The currently selected X coordinate position
  if (tempPositionY == undefined) tempPositionY = xdata.length - 1; // The currentl
  const [startTimeExport, setStartTimeExport] = useState(startTime);
  const [stopTimeExport, setStopTimeExport] = useState(stopTime);
  const [startTimeExportPicker, setStartTimeExportPicker] = useState(false);
  const [startDateExportPicker, setStartDateExportPicker] = useState(false);
  const [stopTimeExportPicker, setStopTimeExportPicker] = useState(false);
  const [stopDateExportPicker, setStopDateExportPicker] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [positionX, setPositionX] = useState(tempPositionX); // The currently selected X coordinate position
  const [positionY, setPositionY] = useState(tempPositionY); // The currently selected X coordinate position
  const [name, setName] = useState("");
  const [alertUpdateLoading, setAlertUpdateLoading] = useState(false);
  console.log("Enabled Axis:", enabledAxis);
  const login = useGoogleLogin({
    scope: "https://www.googleapis.com/auth/drive.file",
    onSuccess: async (tokenResponse) => {
      console.log("tokenResponse:", tokenResponse);
      let token = tokenResponse.token_type + " " + tokenResponse.access_token;
      if (tool.mac) {
        await newSheet(
          {
            fileType: "googleSheetData",
            target: {
              type: "tool",
              mac: tool.mac,
              channels: enabledChannels,
              startTime: HelperService.getEpoch(customStartTime),
              stopTime: HelperService.getEpoch(customStopTime),
            },
          },
          name,
          token
        );
      } else {
        await newSheet(
          {
            fileType: "googleSheetData",
            target: {
              type: "tool",
              share_id: tool.share_id,
              channels: enabledChannels,
              startTime: HelperService.getEpoch(customStartTime),
              stopTime: HelperService.getEpoch(customStopTime),
            },
          },
          name,
          token
        );
      }
      setSheetLoading(false);
      setShowExport(false);
      return;
    },
  });
  const navToExport = () => {
    console.log("DATA TO EXPORT!");
    let now = new Date();
    setName(
      tool.settings.toolName + "_" + (now.getMonth() + 1) + "-" + now.getDate()
    );
    let sliderStart = graphData.normalData[0][0];
    let sliderStop = graphData.normalData[graphData.normalData.length - 1][0];
    min = sliderStart.toFixed(0);
    max = sliderStop.toFixed(0);

    console.log(
      "sliderStart:",
      sliderStart,
      "sliderStop:",
      sliderStop,
      "min:",
      min,
      "max:",
      max
    );
    updateSliderTime(sliderStart, true);
    updateSliderTime(sliderStop, false);
    setShowExport(true);
  };
  function updatePositionX(x) {
    console.log("updatePositionX:", x);
    tempPositionX = x > -1 ? x * multiplier : x;
    setPositionX(tempPositionX);
    if (x >= 0) {
      setStartTimeExport(new Date(xdataZoomed[x] * 1000));
      if (tempPositionX >= tempPositionY && tempPositionY >= 0) {
        if (x < xdataZoomed.length - 1) {
          tempPositionY = tempPositionX + 1;
          setPositionY(tempPositionX + 1);
          setStopTimeExport(new Date(xdataZoomed[x + 1] * 1000));
        } else {
          tempPositionY = tempPositionX;
          setPositionY(tempPositionX);
          setStopTimeExport(new Date(xdataZoomed[x] * 1000));
        }
      }
    }
  }
  function updatePositionY(x) {
    console.log("updatePositionY:", x);
    tempPositionY = x > -1 ? x * multiplier : x;
    setPositionY(tempPositionY);
    if (x >= 0) {
      setStopTimeExport(new Date(xdataZoomed[x] * 1000));
      if (tempPositionY <= tempPositionX && tempPositionX >= 0) {
        if (x > 0) {
          tempPositionX = tempPositionY - 1;
          setPositionX(tempPositionY - 1);
          setStartTimeExport(new Date(xdataZoomed[x - 1] * 1000));
        } else {
          tempPositionX = tempPositionY;
          setPositionX(tempPositionY);
          setStartTimeExport(new Date(xdataZoomed[x] * 1000));
        }
      }
    }
  }
  function updateSliderTime(timeVal, start) {
    //start true stop false
    console.log(
      "updating Slider time:",
      timeVal,
      "start:",
      start,
      "startTimeExport:",
      startTimeExport,
      "stopTimeExport:",
      stopTimeExport
    );
    let startEpoch = HelperService.getEpoch(startTimeExport);
    let stopEpoch = HelperService.getEpoch(stopTimeExport);
    let value = _.findIndex(xdataZoomed, function (o) {
      return o == timeVal;
    }); //index
    let closest;
    if (value == -1) {
      //Index not found? Find closest timestamp in data
      closest = xdataZoomed.reduce(function (prev, curr) {
        return Math.abs(curr - timeVal) < Math.abs(prev - timeVal)
          ? curr
          : prev;
      });
      value = _.findIndex(xdataZoomed, function (o) {
        return o == closest;
      });
    }
    console.log(
      "timeVal",
      timeVal,
      "min",
      min,
      "max",
      max,
      "startEpoch",
      startEpoch,
      "stopEpoch",
      stopEpoch,
      "value:",
      value
    );
    console.log("xdataZoomed length:", xdataZoomed.length);
    console.log("xdataZoomed:", xdataZoomed);
    if (start) {
      if (timeVal < min) {
        console.log("BEFORE MIN");
        updatePositionX(-1);
        setStartTimeExport(new Date(timeVal * 1000));
        if (timeVal > stopEpoch) {
          updatePositionY(-1);
          setStopTimeExport(new Date(timeVal * 1000));
        }
      } else if (timeVal > max) {
        console.log("AFTER MAX");
        updatePositionX(-2);
        setStartTimeExport(new Date(timeVal * 1000));
        if (timeVal > stopEpoch) {
          updatePositionY(-2);
          setStopTimeExport(new Date(timeVal * 1000));
        }
      } else {
        console.log("ON GRAPH");
        updatePositionX(Number(value));
        setStartTimeExport(new Date(timeVal * 1000));
      }
    } else {
      if (timeVal < min) {
        console.log("BEFORE MIN");
        updatePositionY(-1);
        setStopTimeExport(new Date(timeVal * 1000));
        if (timeVal < startEpoch) {
          updatePositionX(-1);
          setStartTimeExport(new Date(timeVal * 1000));
        }
      } else if (timeVal > max) {
        console.log("AFTER MAX");
        updatePositionY(-2);
        setStopTimeExport(new Date(timeVal * 1000));
        if (timeVal < startEpoch) {
          updatePositionX(-2);
          setStartTimeExport(new Date(timeVal * 1000));
        }
      } else {
        console.log("ON GRAPH");
        updatePositionY(Number(value));
        setStopTimeExport(new Date(timeVal * 1000));
      }
    }
  }
  const CustomDashedLines = (props) => {
    console.log("Custom Component Props:", props);

    return (
      <svg
        width={props.width + 20}
        height={props.height}
        x={-10}
        style={{ position: "absolute" }}
        onMouseDown={(event) => {
          console.log("MouseDown Event:", event);
          moving = true;
          let position = event.nativeEvent.layerX - 10;
          let newPosition = Math.round(position / multiplier);
          if (newPosition < 0) newPosition = 0;
          if (newPosition > xdataZoomed.length - 1)
            newPosition = xdataZoomed.length - 1;
          if (
            Math.abs(position - positionX) <= Math.abs(position - positionY)
          ) {
            currSlider = 0;
            updatePositionX(newPosition);
          } else {
            currSlider = 1;
            updatePositionY(newPosition);
          }
        }}
        onMouseMove={(event) => {
          if (moving) {
            console.log("MouseMove Event:", event);
            let position = event.nativeEvent.layerX - 10;
            let newPosition = Math.round(position / multiplier);
            if (newPosition < 0) newPosition = 0;
            if (newPosition > xdataZoomed.length - 1)
              newPosition = xdataZoomed.length - 1;
            if (currSlider == 0) {
              updatePositionX(newPosition);
            } else {
              updatePositionY(newPosition);
            }
          }
        }}
        onMouseLeave={(event) => {
          console.log("MouseUp Leave:", event);
          moving = false;
        }}
        onMouseUp={(event) => {
          console.log("MouseUp Event:", event);
          moving = false;
        }}
      >
        {/* Transparent rect to capture mouse events */}
        <rect
          x={0}
          y={0}
          width={props.width + 20}
          height={props.height}
          fill={Colors.transparent}
        />
        {/* Dashed line for the start time */}
        {positionX >= 0 ? (
          <line
            x1={positionX + 10}
            x2={positionX + 10}
            y1={0}
            y2={previewHeight - 35}
            stroke={Colors.lightGrey}
            strokeWidth="2"
            strokeDasharray={[6, 3]}
          />
        ) : (
          <></>
        )}
        {positionX >= 0 ? (
          <Icon
            svg={sliderIcon}
            size="s20"
            aspect={1}
            x={positionX}
            y={previewHeight - 35}
          />
        ) : (
          <></>
        )}
        {positionX == -1 ? (
          <Icon
            svg={leftIcon}
            size="s20"
            aspect={1}
            x={0}
            y={previewHeight - 35}
            color={Colors.vlightGrey}
          />
        ) : (
          <></>
        )}
        {positionX == -2 ? (
          <Icon
            svg={rightIcon}
            size="s20"
            aspect={1}
            x={previewWidth - 20}
            y={previewHeight - 35}
            color={Colors.vlightGrey}
          />
        ) : (
          <></>
        )}
        {/* Dashed line for the stop time */}
        {positionY >= 0 ? (
          <line
            x1={positionY + 10}
            x2={positionY + 10}
            y1={0}
            y2={previewHeight - 35}
            stroke={Colors.lightGrey}
            strokeWidth="2"
            strokeDasharray={[6, 3]}
          />
        ) : (
          <></>
        )}
        {positionY >= 0 ? (
          <Icon
            svg={sliderIcon}
            size="s20"
            aspect={1}
            x={positionY}
            y={previewHeight - 35}
          />
        ) : (
          <></>
        )}
        {positionY == -1 ? (
          <Icon
            svg={leftIcon}
            size="s20"
            aspect={1}
            x={0}
            y={previewHeight - 35}
            color={Colors.vlightGrey}
          />
        ) : (
          <></>
        )}
        {positionY == -2 ? (
          <Icon
            svg={rightIcon}
            size="s20"
            aspect={1}
            x={previewWidth - 20}
            y={previewHeight - 35}
            color={Colors.vlightGrey}
          />
        ) : (
          <></>
        )}
      </svg>
    );
  };

  console.log(
    "Alert Info\nupper:",
    upper,
    "\nlower:",
    lower,
    "\nupperAlert:",
    upperAlert,
    "\nlowerAlert:",
    lowerAlert
  );
  console.log(
    "customStartTime:",
    customStartTime,
    "\ncustomStopTime:",
    customStopTime
  );
  let enabledCount = 0;
  enabled.forEach((attribute) => {
    if (attribute) enabledCount++;
  });
  function updateDateTime(value, start, time, exporting) {
    console.log("updateDateTime");
    console.log(
      "\nvalue:",
      value,
      "\nstart:",
      start,
      "\ntime",
      time,
      "\nexporting:",
      exporting
    );

    var tempDate;
    var year;
    var month;
    var date;
    var hrs;
    var mins;

    if (value == null || value == undefined) {
    } else {
      if (exporting) {
        if (start) {
          if (time) {
            tempDate = new Date(value); //new Date(value.nativeEvent.timestamp)
            hrs = tempDate.getHours();
            mins = tempDate.getMinutes();
            tempDate = new Date(value);
            tempDate.setHours(hrs);
            tempDate.setMinutes(mins);
            tempDate.setSeconds(0);
            console.log("Changing export start time to:", tempDate);
            updateSliderTime(HelperService.getEpoch(tempDate), true);
            setStartTimeExportPicker(false);
          } else {
            tempDate = new Date(value); //new Date(value.nativeEvent.timestamp)
            year = tempDate.getFullYear();
            month = tempDate.getMonth();
            date = tempDate.getDate();
            tempDate = new Date(value);
            tempDate.setFullYear(year);
            tempDate.setMonth(month);
            tempDate.setDate(date);
            console.log("Changing export start date to:", tempDate);
            updateSliderTime(HelperService.getEpoch(tempDate), true);
            setStartDateExportPicker(false);
          }
        } else {
          if (time) {
            tempDate = new Date(value); //new Date(value.nativeEvent.timestamp)
            hrs = tempDate.getHours();
            mins = tempDate.getMinutes();
            tempDate = new Date(value);
            tempDate.setHours(hrs);
            tempDate.setMinutes(mins);
            tempDate.setSeconds(0);
            console.log("Changing export stop time to:", tempDate);
            updateSliderTime(HelperService.getEpoch(tempDate), false);
            setStopTimeExportPicker(false);
          } else {
            tempDate = new Date(value); //new Date(value.nativeEvent.timestamp)
            year = tempDate.getFullYear();
            month = tempDate.getMonth();
            date = tempDate.getDate();
            tempDate = new Date(value);
            tempDate.setFullYear(year);
            tempDate.setMonth(month);
            tempDate.setDate(date);
            console.log("Changing export stop date to:", tempDate);
            updateSliderTime(HelperService.getEpoch(tempDate), false);
            setStopDateExportPicker(false);
          }
        }
      } else {
        setAllSites({ ...allSites, graphUpdated: false });
        if (start) {
          tempDate = new Date(value); //new Date(value.nativeEvent.timestamp)
          year = tempDate.getFullYear();
          month = tempDate.getMonth();
          date = tempDate.getDate();
          tempDate = new Date(value);
          tempDate.setFullYear(year);
          tempDate.setMonth(month);
          tempDate.setDate(date);
          tempDate.setHours(0);
          tempDate.setMinutes(0);
          tempDate.setSeconds(0);
          console.log("Changing start date to:", tempDate);
          setCustomStartTime(tempDate);
          setStartDatePicker(false);
        } else {
          tempDate = new Date(value); //new Date(value.nativeEvent.timestamp)
          year = tempDate.getFullYear();
          month = tempDate.getMonth();
          date = tempDate.getDate();
          tempDate = new Date(value);
          tempDate.setFullYear(year);
          tempDate.setMonth(month);
          tempDate.setDate(date);
          tempDate.setHours(23);
          tempDate.setMinutes(59);
          tempDate.setSeconds(59);
          console.log("Changing stop date to:", tempDate);
          setCustomStopTime(tempDate);
          setStopDatePicker(false);
        }
      }
    }
  }
  const CustomPoint = (props) => {
    const { currentSlice } = props;
    console.log("CustomPoint props:", props);
    // it will show the current point
    if (currentSlice) {
      return (
        <g>
          <line
            x1={currentSlice.points[0].x}
            x2={currentSlice.points[0].x}
            y1={0}
            y2={height - 20}
            stroke={Colors.lightGrey}
            strokeWidth="1"
            strokeDasharray={[6, 3]}
          />
          {currentSlice.points.map((point) => {
            if (point.id.includes("upper") || point.id.includes("lower"))
              return <></>;
            return (
              <circle
                fill={Colors.darkGrey}
                r={3}
                strokeWidth={1}
                stroke={Colors.white}
                fillOpacity={1}
                cx={point.x}
                cy={point.y}
              />
            );
          })}
        </g>
      );
    }
  };
  const getGraphData = async (
    tool,
    dataID,
    scope,
    attributeArray,
    allSites
  ) => {
    let graphStore = "customScope";
    console.log("scope:", "week");
    console.log("state:", allSites);
    console.log("graphStore:", graphStore);
    const tempGraphData = _.get(allSites, graphStore, {});
    console.log("tempGraphData:", tempGraphData);
    let myGraphData;
    if (!_.isEmpty(tempGraphData)) {
      //Go through the list of tools
      tempGraphData.forEach((toolData, key) => {
        //find the tool in the state
        if (_.isEqual(key, dataID)) {
          myGraphData = toolData.normalData;
          setGraphData(toolData);
          setStartOfData(toolData.startOfData);
          console.log("CURRENT GRAPH DATA:", toolData);
          // _.assign(myGraphData, toolData)//assign to returned tool object
        }
      });
    }
    console.log("myGraphData:", myGraphData);
    console.log("attributeArray:", attributeArray);
    if (myGraphData == undefined) return [];
    let convertedItems = [];
    xdata = [];
    attributeArray.forEach((attribute, i) => {
      if (i > 0 && attribute == "sthp_temp") {
        //Only build temp data
        convertedItems[0] = {
          id: attribute,
          color: Colors.greenMain,
          data: [],
        };
        convertedItems[1] = { id: "upper", color: Colors.orangeMain, data: [] };
        convertedItems[2] = { id: "lower", color: Colors.redMain, data: [] };
        let currentData = new Array();
        let upperData = [];
        let lowerData = [];
        myGraphData.forEach((item, index) => {
          let date = new Date(item[0] * 1000);
          if (isNaN(Number(item[i]))) {
            currentData.push({ x: date, y: null });
          } else {
            currentData.push({ x: date, y: item[i] });
          }
          if (_.has(tool, "alerts") && tool.alerts.length > 0) {
            tool.alerts.forEach((alert) => {
              if (
                alert.alertMode == "sensorMode" &&
                alert.settings.alertEnable == true &&
                alert.settings.testField == "sthp_temp"
              ) {
                let normalTestValue = alert.settings.testValue;
                let toolData = tempGraphData.get(dataID);
                console.log("toolData:", toolData);
                console.log("enabledAxis:", enabledAxis);
                if (enabledAxis && enabledAxis[0]?.max != enabledAxis[0]?.min) {
                  normalTestValue =
                    !isNaN(alert.settings.testValue) &&
                    alert.settings.testValue != null
                      ? (alert.settings.testValue - enabledAxis[0].min) /
                        (enabledAxis[0].max - enabledAxis[0].min)
                      : alert.settings.testValue;
                }
                console.log("normalTestValue:", normalTestValue);
                if (alert.settings.testCondition == "GT") {
                  if (_.isEqual(upperAlert, undefined)) {
                    cloudUpperLimit = alert.settings.testValue;
                    setUpper(alert.settings.testValue);
                    setUpperAlert(alert.alert_id);
                  }
                  console.log("new entry:", { x: date, y: normalTestValue });
                  upperData.push({ x: date, y: normalTestValue });
                  console.log("upperData:", upperData);
                }
                if (alert.settings.testCondition == "LS") {
                  if (_.isEqual(lowerAlert, undefined)) {
                    cloudLowerLimit = alert.settings.testValue;
                    setLower(alert.settings.testValue);
                    setLowerAlert(alert.alert_id);
                  }
                  console.log("new entry:", { x: date, y: normalTestValue });
                  lowerData.push({ x: date, y: normalTestValue });
                  console.log("lowerData:", lowerData);
                }
              }
            });
          }
          if (i == 1) xdata.push(item[0]);
        });
        convertedItems[0].data = currentData;
        convertedItems[1].data = upperData;
        convertedItems[2].data = lowerData;
      }
    });
    setChartUpdated(true);
    setXdataZoomed(xdata);
    console.log("xdata length:", xdata.length);
    multiplier = (previewWidth - 20) / (xdata.length - 1);
    console.log("convertedItems:", convertedItems);

    return convertedItems;
  };
  useEffect(() => {
    setChartUpdated(false);
    setStartTime(
      displayDataZoomed[0]?.data != undefined &&
        displayDataZoomed[0]?.data.length > 0 &&
        displayDataZoomed[0]?.data[0]?.x != undefined
        ? displayDataZoomed[0]["data"][0]["x"]
        : undefined
    );
    setStopTime(
      displayDataZoomed[0]?.data[displayDataZoomed[0]?.data.length - 1] !=
        undefined
        ? displayDataZoomed[0]["data"][displayDataZoomed[0]?.data.length - 1][
            "x"
          ]
        : undefined
    );
    setStartTimeExport(
      displayDataZoomed[0]?.data != undefined &&
        displayDataZoomed[0]?.data.length > 0 &&
        displayDataZoomed[0]?.data[0]?.x != undefined
        ? displayDataZoomed[0]["data"][0]["x"]
        : undefined
    );
    setStopTimeExport(
      displayDataZoomed[0]?.data[displayDataZoomed[0]?.data.length - 1] !=
        undefined
        ? displayDataZoomed[0]["data"][displayDataZoomed[0]?.data.length - 1][
            "x"
          ]
        : undefined
    );
    // setLoading(false)
    setChartUpdated(true);
  }, [displayDataZoomed]);
  useEffect(() => {
    multiplier = (previewWidth - 20) / (xdataZoomed.length - 1);
  }, [xdataZoomed]);
  useEffect(() => {
    const updateToolSettingsCloud = async () => {
      await updateToolSettings(tool, {
        graphPropsDashboard: { enY: enabledAxis },
      });
      // let settings = await getToolSettings(tool).then((settings) => settings)
      let tempAllSites = { ...allSites };
      tempAllSites[tool.mac] = tool;
      setAllSites({ ...tempAllSites });
    };
    return () => {
      if (
        tool &&
        tool.mac &&
        allSites &&
        enabledAxis &&
        !_.isEqual(enabledAxis, [true, true, true, true, true, true]) &&
        !window.location.pathname.includes("sensor")
      ) {
        console.log("Updating Tool Settings Cloud");
        console.log("pathname:", window.location.pathname);
        updateToolSettingsCloud();
      }
    };
  }, [window.location.pathname, tool, allSites, enabledAxis]);
  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      console.log("RESIZE:", entries[0].contentRect);
      if (entries[0].contentRect.width > 0) {
        // && entries[0].contentRect.height > 0
        console.log("New Width:", entries[0].contentRect.width);
        console.log("New Height:", entries[0].contentRect.height);
        setWidth(entries[0].contentRect.width);
        setHeight(entries[0].contentRect.height);
        lastHeight = entries[0].contentRect.height;
        lastWidth = entries[0].contentRect.width;
      }
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => ref.current && observer.unobserve(ref.current);
  }, [ref.current, enabled, enabledAxis, fullscreen, expandedSensor]);
  useEffect(() => {
    console.log("Updating AllSites to ", {
      ...allSites,
      fullscreen: fullscreen,
    });
    if (!_.isEqual({ ...allSites, fullscreen: fullscreen }, allSites))
      setAllSites({ ...allSites, fullscreen: fullscreen });
  }, [fullscreen]);
  useEffect(() => {
    console.log("TOOL CHANGED!");
    setAllSites({ ...allSites, graphUpdated: false });
    let tempStore = _.find(allSites?.stores?.Items, function (o) {
      return o.tools.includes(mac);
    });

    if (tempStore) {
      setCurrentStore(tempStore);
    } else {
      setCurrentStore();
    }
    setUpperAlert();
    setUpper();
    setLowerAlert();
    setLower();
    cloudLowerLimit = undefined;
    cloudUpperLimit = undefined;
  }, [mac, allSites[mac]]);
  useEffect(() => {
    const updateGraphPropsDashboard = async () => {
      if (
        tool &&
        tool.mac &&
        mac &&
        tool.mac == mac &&
        enabledAxis &&
        !_.isEqual(enabledAxis, [true, true, true, true, true, true]) &&
        !_.isEqual(enabledAxis, lastEnabledAxis)
      ) {
        lastEnabledAxis = enabledAxis;
        console.log("Updating Graph Props Dashboard.:", enabledAxis);
        let tempTool = _.cloneDeep({ ...tool });
        if (
          _.has(tool, "settings") &&
          _.has(tool.settings, "graphPropsDashboard")
        ) {
          if (!_.isEqual(tool.settings.graphPropsDashboard.enY, enabledAxis))
            tempTool.settings.graphPropsDashboard.enY = enabledAxis;
        } else if (_.has(tool, "settings")) {
          tempTool.settings.graphPropsDashboard = { enY: enabledAxis };
        }
        if (!_.isEqual(graphPropsDashboard?.enY, enabledAxis)) {
          graphPropsDashboard.enY = enabledAxis;
        }
      }
    };
    updateGraphPropsDashboard();
  }, [enabledAxis, tool]);

  // Theres variation between how things are done on the Store Overview + Sensor Page to pull in Tool data
  // Doing this for now to point to the correct tool 
  // Will need to standardize a way of doing this so its the same across components and easy to maintain
  useEffect(() => {
    if (currentStore) setTool(currentStore[mac]);
  }, [currentStore]);

  useEffect(() => {
   
    let apiAttributes;
    setDisplayDataZoomed([]);
    setXdataZoomed([]);
    setLoading(true);
    

    const getLiveGraphDataEffect = async () => {
      console.log("getLiveGraphData useEffect:", allSites);
      if (tool != undefined && tool.toolType == ToolTypes.THP) {
        attributeArray = ["ts"].concat(...THP_CH_ENUM);
        apiAttributes = attributeArray.join();
        // if(!graphDataPulled){
        let tempAllSites = { ...allSites };

        await addGraphLiveData(
          { ...tempAllSites },
          setAllSites,
          user.signInUserSession.idToken.jwtToken,
          tool,
          scope,
          scopeAdjustment[scope],
          { start: customStartTime, end: customStopTime },
          null
        );
        // graphDataPulled = true;
        let temp = [];
        if (_.has(tool, "data_id")) {
          temp = await getGraphData(tool, tool.data_id, scope, attributeArray, {
            ...allSites,
          });
        } else if (_.has(tool, "share_id")) {
          temp = await getGraphData(
            tool,
            tool.share_id,
            scope,
            attributeArray,
            { ...allSites }
          );
        }
        if (temp.length > 0) tempData = temp;

        let tempDisplayData = [];
        console.log("Setting Display Data.");
        console.log("tempData:", tempData);
        console.log("enabled:", enabled);
        tempData.forEach((attribute, index) => {
          if (
            enabled[index] ||
            attribute.id == "upper" ||
            attribute.id == "lower"
          ) {
            tempDisplayData[index] = attribute;
          } else {
            tempDisplayData[index] = attribute;
            attribute.data.forEach((point, i) => {
              tempDisplayData[index].data[i] = { x: point.x, y: null };
            });
          }
        });
        // if(_.isEqual([true,true,true,true,true,true],enabledAxis) && tool.mac == mac) setEnabledAxis(defaultEnAxis)
        if (tool != undefined && tool.mac) {
          console.log("Tool:", tool);
          defaultEn = THP_ENABLED_ARRAY(tool, null);
          defaultEnAxis = THP_DEFAULT_Y_AXIS(tool.settings.channels);
          yAxisEnabledCount = 0;
          defaultEnAxis.forEach((axis) => {
            if (
              axis.enabled &&
              axis.channels.some((channel) => enabled[channel] == true)
            ) {
              console.log("Axis enabled!", axis);
              yAxisEnabledCount++;
            }
          });
          console.log("defaultEnAxis:", defaultEnAxis);
          console.log("tool.mac", tool.mac);
          console.log('_.has(tool,"settings"):', _.has(tool, "settings"));
          console.log(
            '_.has(tool.settings,"graphPropsDashboard"):',
            _.has(tool.settings, "graphPropsDashboard")
          );
          console.log(
            "!_.isEmpty(tool.settings.graphPropsDashboard):",
            !_.isEmpty(tool.settings.graphPropsDashboard)
          );
          console.log(
            '_.has(tool.settings.graphPropsDashboard,"enY"):',
            _.has(tool.settings.graphPropsDashboard, "enY")
          );
          if (
            _.has(tool, "settings") &&
            _.has(tool.settings, "graphPropsDashboard") &&
            !_.isEmpty(tool.settings.graphPropsDashboard) &&
            _.has(tool.settings.graphPropsDashboard, "enY")
          ) {
            console.log("tool graph props:", tool.settings.graphPropsDashboard);
            graphPropsDashboard.enY = tool.settings.graphPropsDashboard.enY;
            if (!_.isEqual(graphPropsDashboard.enY, enabledAxis))
              setEnabledAxis(graphPropsDashboard.enY);
          } else {
            console.log("default tool graph props:");
            graphPropsDashboard = {
              enX: true,
              start: null,
              end: null,
              en: defaultEn,
              enY: defaultEnAxis,
              enYCount: defaultEnAxis.length,
              currZoom: { x: 0, scale: 1 },
              customScope: false,
            };
            if (!_.isEqual(defaultEnAxis, enabledAxis) && tool.mac == mac)
              setEnabledAxis(defaultEnAxis);
          }
          console.log("defaultEn:", defaultEn);
        } else {
          console.log("Can't change Y Axis. Tool:", tool);
        }
        console.log("tempDisplayData:", tempDisplayData);
        setDisplayDataZoomed(tempDisplayData);
        setChartUpdated(true);
        channels[0] = tool.settings.channels.sthp_temp.name;
        tempUnits[0] = tool.settings.channels.sthp_temp.unit;
        channelValues[0] = tool.sensor.sthp_temp;
        channelNames[0] = "sthp_temp";
        if (allSites.graphUpdated) setLoading(false);
      }
    };
    if (window?.location?.pathname.includes("sensor")) {
      try {
        if (
          user &&
          tool &&
          _.has(user, "signInUserSession") &&
          _.has(user.signInUserSession, "idToken") &&
          _.has(user.signInUserSession.idToken, "jwtToken")
        ) {
          getLiveGraphDataEffect();
        } else {
          console.log("Can't pull data yet");
        }
      } catch (error) {
        console.log("unexpected error...");
      }
      if (tool?.toolType) {
        if (!ToolTypes.THP.localeCompare(tool.toolType)) {
          enabledChannels = THP_ENABLED_CHANNELS(tool, false);
        }
        tempChannelSelector = {};
        enabledChannels.forEach((channel) => {
          _.set(tempChannelSelector, channel, true);
        });
      }
    }
  }, [
    mac,
    allSites?.graphUpdated,
    window?.location?.pathname,
    customStartTime,
    customStopTime,
    tool,
  ]);

  useEffect(() => {
    let fileType = "";
    if (formatList[format] == "CSV") fileType = "csv";
    if (formatList[format] == "Excel XLSX") fileType = "xlsx";
    if (formatList[format] == "PDF") fileType = "pdf";
    if (exportInitiated) {
      if (exportLoading) {
        try {
          if (tool.mac) {
            exportFile({
              fileType: fileType,
              target: {
                type: "tool",
                mac: tool.mac,
                channels: enabledChannels,
                startTime: HelperService.getEpoch(startTimeExport),
                stopTime: HelperService.getEpoch(stopTimeExport),
              },
              settings: { name: name },
            }).then((result) => {
              console.log("Export result:", result);
              setExportLoading(false);
              setShowExport(false);
              if (_.has(result, "downloadLink")) {
                window.open(result.downloadLink);
              }
            });
          } else {
            exportFile({
              fileType: fileType,
              target: {
                type: "tool",
                share_id: tool.share_id,
                channels: enabledChannels,
                startTime: HelperService.getEpoch(startTimeExport),
                stopTime: HelperService.getEpoch(stopTimeExport),
              },
              settings: { name: name },
            }).then((result) => {
              console.log("Export result:", result);
              setExportLoading(false);
              setShowExport(false);
              if (_.has(result, "downloadLink")) {
                window.open(result.downloadLink);
              }
            });
          }
        } catch (error) {
          console.log("EXPORT ERROR:", error);
        }
      } else {
        // onShare()
      }
    } else {
      console.log("NOT YET CODED");
    }
  }, [exportLoading]);

  const handleSaveAlarmSetPoints = async (event) => {
    event.stopPropagation();
    setAlertUpdateLoading(true);

    if (upper != cloudUpperLimit || lower != cloudLowerLimit) {
      let settings;
      let result;
      let newAlerts;

      if (upperAlert === undefined) {
        // New Alert logic here
      } else {
        // Edit Alert
        if (upper != cloudUpperLimit) {
          settings = { testValue: Number(upper) };
          result = await updateAlert(
            tool?.mac ? { mac: mac } : { share_id: mac },
            upperAlert,
            settings
          );
        }
      }

      if (lowerAlert === undefined) {
        // New Alert logic here
      } else {
        // Edit Alert
        if (lower != cloudLowerLimit) {
          settings = { testValue: Number(lower) };
          result = await updateAlert(
            tool?.mac ? { mac: mac } : { share_id: mac },
            lowerAlert,
            settings
          );
        }
      }

      await HelperService.delayMs(1000);
      newAlerts = await getAlerts(tool).then((result) => result);
      if (newAlerts) {
        let tempTool = _.cloneDeep(tool);
        tempTool.alerts = newAlerts;
        if (!_.isEqual(tempTool, tool)) setTool(tempTool);
      }
    }

    setAlertUpdateLoading(false);
  };

  return (
    <>
      <Group justify="space-between">
        <Button variant="default" h={43}>
          <Text>Edit Sensor</Text>
        </Button>

        <Button
          color={Colors.main}
          variant="outline"
          onClick={() => {
            if (location.state?.lastStore?.project_id) {
              navigate("/stores/" + location.state?.lastStore?.project_id);
            } else {
              console.log("No last store");
              navigate("/stores/" + currentStore?.project_id);
            }
          }}
          radius="sm"
          mr="md"
          h={43}
        >
          <MdKeyboardArrowLeft size="1.6rem" />
          <Text>Back To Stores</Text>
        </Button>
      </Group>
      <Space h="md" />

      <Paper p="sm">
        {window?.location?.pathname.includes("add") ? (
          <View
            style={{
              display: "flex",
              flexDirection: "column",
              height: "calc(100vh - 80px - 20px)",
              ...Metrics.horizontalPadding,
              ...Metrics.smallVerticalMargin,
              overflow: "auto",
            }}
          >
            <Text as="md" weight={"regular"} color={"textSecondary"}>
              Add Store
            </Text>
          </View>
        ) : window?.location?.pathname.includes("edit") ? (
          <View
            style={{
              display: "flex",
              flexDirection: "column",
              height: "calc(100vh - 80px - 20px)",
              ...Metrics.horizontalPadding,
              ...Metrics.smallVerticalMargin,
              overflow: "auto",
            }}
          >
            <Text as="md" weight={"regular"} color={"textSecondary"}>
              Edit Store
            </Text>
          </View>
        ) : mac ? (
          <View
            style={
              fullscreen
                ? {
                    display: "flex",
                    flexDirection: "column",
                    height: "calc(100vh)",
                    overflow: "auto",
                  }
                : {
                    display: "flex",
                    flexDirection: "column",
                    height: "calc(100vh - 80px - 20px)",
                    ...Metrics.horizontalPadding,
                    ...Metrics.smallVerticalMargin,
                    overflow: "auto",
                  }
            }
          >
            {!fullscreen && tool && (
              <div>
                <Text size="xl" fw={500}>
                  {tool?.settings?.toolName}
                </Text>

                <Text size="md">
                  {"Location: " + tool?.settings?.toolLocation}
                </Text>
              </div>
            )}

            <View
              style={{
                ...Helpers.fillCol,
                backgroundColor: Colors.white,
                marginTop: Spacing.sm,
                overflow: "hidden",
              }}
            >
              <Row.ToolGraphOptions
                tool={tool}
                navToGraphProps={() => {
                  setShowGraphProps(true);
                }}
                navToExport={
                  displayDataZoomed[0]?.data?.length < 2 ||
                  (tool?.share_id &&
                    _.has(recipient, "recipientSettings") &&
                    recipient.recipientSettings.allowExport == false) ||
                  loading
                    ? null
                    : navToExport
                }
                setFullscreen={setFullscreen}
                fullscreen={fullscreen}
                resetZoom={() => {}}
                zoom={false}
                startValue={customStartTime}
                endValue={customStopTime}
                onPressStartDate={() => setStartDatePicker(true)}
                onPressEndDate={() => setStopDatePicker(true)}
                onChangeStartDate={(value) => updateDateTime(value, true)}
                onChangeEndDate={(value) => updateDateTime(value, false)}
              />
              <Divider />
              <Space h={50} />
              <View
                style={{
                  ...Helpers.fillRow,
                  backgroundColor: Colors.white,
                  overflow: "hidden",
                }}
              >
                {enabledAxis ? (
                  enabledAxis.map((axis, index) =>
                    Graph.AxisUsed(xdataZoomed.length, axis, enabled) &&
                    displayDataZoomed[0]?.data?.length > 1 &&
                    height ? (
                      <Graph.YAxis
                        units={tempUnits[index]}
                        isLoading={loading}
                        axis={axis}
                        toolType={"sthp"}
                        maxData={graphData.maxData}
                        minData={graphData.minData}
                        index={index}
                        attributes={graphData.attributes}
                      />
                    ) : (
                      <></>
                    )
                  )
                ) : (
                  <></>
                )}
                <div
                  ref={ref}
                  style={{ display: "flex", width: "100%", height: "100%" }}
                >
                  <div
                    style={{
                      display: "flex",
                      width: width,
                      height: height,
                      position: "absolute",
                      ...Helpers.row,
                    }}
                  >
                    {displayDataZoomed[0]?.data?.length > 1 &&
                    chartUpdated &&
                    !loading ? (
                      <ResponsiveLine
                        data={chartUpdated ? displayDataZoomed : []}
                        margin={{ top: 10, right: 20, bottom: 10, left: 10 }}
                        xScale={{
                          type: "time",
                          format: "native",
                          // precision: 'hour',
                        }}
                        yScale={{
                          type: "linear",
                          min: 0,
                          max: 1,
                          stacked: false,
                          reverse: false,
                        }}
                        gridYValues={[
                          0,
                          1 / 6,
                          (2 * 1) / 6,
                          (3 * 1) / 6,
                          (4 * 1) / 6,
                          (5 * 1) / 6,
                          1,
                        ]}
                        gridXValues={verticalLines}
                        // yFormat=" >-.2f"
                        axisTop={null}
                        axisRight={null}
                        axisLeft={null}
                        axisBottom={null}
                        sliceTooltip={({ slice }) => {
                          if (!slice) return <></>;
                          if (_.isEmpty(displayDataZoomed)) return <></>;
                          if (_.isEmpty(tempUnits)) return <></>;
                          if (_.isEmpty(graphData?.convertedData)) return <></>;
                          const apx = (size = 0, min = null) => {
                            if (min) {
                              if ((width / 750) * size > min) return min;
                            }
                            return (width / 750) * size;
                          };
                          const apy = (size = 0, min = null) => {
                            if (min) {
                              if ((height / 750) * size > min) return min;
                            }
                            return (height / 750) * size;
                          };
                          let counted = 0;
                          const countedIncrement = (enabled) => {
                            if (enabled) counted++;
                          };

                          let date = slice.points[0].data.x; //new Date(xdataZoomed[positionX]*1000)
                          console.log("Date:", date);
                          console.log("slice:", slice);
                          console.log("tempUnits:", tempUnits);
                          console.log("graphData:", graphData);
                          enabledCount = 0;
                          slice.points.forEach((attribute) => {
                            if (attribute) enabledCount++;
                          });
                          let longestData = 0;
                          let currentData = "";
                          let index;
                          let dataIndex = graphData.convertedData.findIndex(
                            (x) =>
                              new Date(x[0] * 1000).getTime() === date.getTime()
                          );
                          // newTouchPosition = dataIndex
                          slice.points.forEach((attribute) => {
                            index = attributeArray.findIndex(
                              (x) => x == attribute.serieId
                            );
                            if (
                              _.has(attribute.data, "y") &&
                              attribute.data.y != null &&
                              !isNaN(attribute.data.y)
                            ) {
                              currentData =
                                attribute.data.y.toFixed(2) +
                                " " +
                                tempUnits[index - 1];
                              if (currentData.length > longestData)
                                longestData = currentData.length;
                            }
                          });
                          let dateString =
                            HelperService.formatDate(date, 1) +
                            " " +
                            HelperService.formatTime(date, 0);
                          let timeLength = 8 * (dateString.length + 1);
                          let toolTipWidth = Math.max(
                            100,
                            Math.floor(8 * longestData),
                            timeLength
                          );
                          let toolTipHeight = Math.max(apy(48 + 24), 80);
                          if (!slice) return <></>;
                          return (
                            <Paper
                              h={66}
                              w={130}
                              key="tooltip"
                              withBorder
                              radius="lg"
                              p="sm"
                              style={{ backgroundColor: "#F2F2F4" }}
                            >
                              <Group gap="xs" justify="space-between">
                                <Text fw={700} size="xs">
                                  {HelperService.formatDate(date, 1)}
                                </Text>
                                <Text fw={700} size="xs">
                                  {HelperService.formatTime(date, 0)}
                                </Text>
                              </Group>

                              <line
                                x1={apx(0)}
                                x2={toolTipWidth} //Number(ticks.length)
                                y1={toolTipHeight / (1 + 2) + 4}
                                y2={toolTipHeight / (1 + 2) + 4}
                                stroke={Colors.white}
                                strokeWidth={2}
                              />
                              <Space h="xs" />
                              {attributeArray.map((attribute, i) => {
                                index = slice.points.findIndex(
                                  (point) => point.serieId == attribute
                                );
                                return index > -1 &&
                                  slice.points[index] &&
                                  attribute.includes("sthp_temp") ? (
                                  <Group justify="right">
                                    <Text
                                      fw={700}
                                      size="xs"
                                      c={Colors.greenMain}
                                    >
                                      {_.has(slice.points[index].data, "y") &&
                                      graphData.convertedData[dataIndex][i] !=
                                        null &&
                                      !isNaN(
                                        graphData.convertedData[dataIndex][i]
                                      )
                                        ? graphData.convertedData[dataIndex][
                                            i
                                          ].toFixed(2) +
                                          " " +
                                          tempUnits[i - 1]
                                        : "null"}
                                    </Text>
                                    {countedIncrement(slice.points[index])}
                                  </Group>
                                ) : (
                                  <></>
                                );
                              })}
                            </Paper>
                          );
                        }}
                        colors={(d) => d.color}
                        enablePoints={false}
                        enableSlices="x"
                        // crosshairType="cross"
                        legends={[]}
                        enableCrosshair={false}
                        motionConfig="gentle"
                        layers={[
                          "grid",
                          "markers",
                          "axes",
                          "areas",
                          "crosshair",
                          "lines",
                          "points",
                          CustomPoint,
                          "slices",
                          "mesh",
                          "legends",
                        ]}
                        animate={false}
                      />
                    ) : (
                      <View style={{ ...Helpers.fillCenter, height: "100%" }}>
                        {console.log("displayDataZoomed:", displayDataZoomed)}
                        {!chartUpdated || loading ? (
                          <Spin size="large" />
                        ) : (
                          <Text
                            as={"xlarge"}
                            color={"darkGrey"}
                            weight={"bold"}
                          >
                            {_.isEqual(displayDataZoomed, []) ||
                            displayDataZoomed[0]?.data?.length == 0
                              ? "No Graph Data Available For This Scope"
                              : "Not Enough Data to Graph"}
                          </Text>
                        )}
                      </View>
                    )}
                  </div>
                </div>
              </View>
              <View style={{ marginLeft: 50, width: width, height: 20 }}>
                {xdataZoomed.length > 1 &&
                !loading &&
                displayDataZoomed[0]?.data?.length > 1 ? (
                  <Graph.XAxis
                    xdata={xdataZoomed}
                    isLoading={loading}
                    yAxisEnabledCount={0}
                    axisWidth={0}
                    horizontalContentInset={{ right: 20, left: 10 }}
                    width={width}
                    landscape={true}
                    verticalLines={verticalLines}
                    setVerticalLines={(lines) => (verticalLines = lines)}
                  />
                ) : (
                  <></>
                )}
              </View>
              <Space h={50} />
              <Divider />
              <Space h={50} />
              {!fullscreen && (
                <>
                  <Text fz={20} fw={450}>
                    Alarm Set Points
                  </Text>

                  <Space h="xs" />
                  <Divider />
                  <Space h="xs" />
                  <Group justify="space-between">
                    <Group>
                      <Group>
                      <Text fw={500} size="sm">
                        Lower Set Point (°F)
                      </Text>
                     
                      <NumberInput
                        value={lower}
                        onChange={setLower}
                        w={155}
                        min={0}
                        max={100}
                        allowDecimal={false}
                        allowNegative={false}
                      />
                      </Group>

                      <Space w="lg" />

                      <Group>
                        <Text fw={500} size="sm">
                          Upper Set Point (°F)
                        </Text>
                      
                        <NumberInput
                          value={upper}
                          onChange={setUpper}
                          w={155}
                          min={0}
                          max={100}
                          allowDecimal={false}
                          allowNegative={false}
                        />
                      </Group>
                    </Group>

                    <Space h='md'/>

                    <Group justify='flex-end'>
                      <Button
                        color={Colors.main}
                        variant="filled"
                        disabled={
                          alertUpdateLoading ||
                          loading ||
                          !chartUpdated ||
                          (lower == cloudLowerLimit && upper == cloudUpperLimit)
                        }
                        loading={alertUpdateLoading}
                        onClick={handleSaveAlarmSetPoints}
                      >
                        Save
                      </Button>
                      <Button
                        color={Colors.main}
                        variant="outline"
                        disabled={
                          alertUpdateLoading ||
                          loading ||
                          !chartUpdated ||
                          (lower == cloudLowerLimit && upper == cloudUpperLimit)
                        }
                        onClick={(event) => {
                          event.stopPropagation();
                          setLower(cloudLowerLimit);
                          setUpper(cloudUpperLimit);
                        }}
                      >
                        Cancel
                      </Button>
                    </Group>
                  </Group>
                </>
              )}
            </View>
          </View>
        ) : (
          <>:</>
        )}
        <Modal
          title="Graph Properties"
          styles={{
            body: {
              overflowY: "auto",
              height: fullscreen ? height * 0.8 : height,
            },
          }}
          open={showGraphProps}
          footer={null}
          onCancel={() => setShowGraphProps(false)}
          onOk={() => setShowGraphProps(false)}
        >
          <Row.Section title={"Y Axis"}></Row.Section>
          {console.log("Enabled Axis:", enabledAxis)}
          {console.log("graphData:", graphData)}
          {console.log(
            "MinData:",
            graphData.minData,
            "MaxData:",
            graphData.maxData
          )}
          {enabledAxis ? (
            enabledAxis.map((axis, index) => {
              if (axis != undefined && _.has(axis, "channels")) {
                console.log("axis.channels:", axis.channels);
                console.log("TOOL_CH_ENUM:", TOOL_CH_ENUM);
              }

              return axis != undefined && _.has(axis, "channels") ? (
                <Row.YAxis //Enable/Disable
                  // enabled={axis.enabled}
                  name={axis.name}
                  channels={axis.channels}
                  icons={axis.channels.map((channel) => icons[channel])}
                  // auto={axis.auto}
                  min={axis.min}
                  max={axis.max}
                  axisIndex={index}
                  enabledAxis={enabledAxis}
                  setEnabledAxis={setEnabledAxis}
                  unit={
                    tool &&
                    tool.settings.channels[TOOL_CH_ENUM[axis.channels[0]]]
                      ?.linearScalingEnable
                      ? tool.settings.channels[TOOL_CH_ENUM[axis.channels[0]]]
                          .linearScalingUnit
                      : tool
                      ? tool.settings.channels[TOOL_CH_ENUM[axis.channels[0]]]
                          ?.unit
                      : ""
                  }
                />
              ) : (
                <></>
              );
            })
          ) : (
            <></>
          )}
        </Modal>
        <Modal
          title="Export"
          open={showExport}
          footer={null}
          onCancel={() => setShowExport(false)}
          onOk={() => setShowExport(false)}
        >
          <View
            style={{
              ...Helpers.fillCol,
              width: "100%",
              height: "100%",
              overflowY: "auto",
            }}
          >
            <Row.Setting
              title="File Name"
              icon={fileIcon}
              setting={name}
              changeSetting={setName}
              setSetting={() => console.log("Changed Name")}
            />
            <Row.Section title="Preview" />
            <View
              style={{
                paddingLeft: 40,
                paddingRight: 40,
                paddingTop: 5,
                height: 45,
                ...Helpers.mainSpaceBetween,
                ...Helpers.row,
                ...Helpers.rowCross,
              }}
            >
              <View
                style={{
                  ...Helpers.rowCenter,
                  backgroundColor: Colors.lineDivider,
                  width: 81,
                  height: 24,
                  borderRadius: 8,
                }}
              >
                <Text numberOfLines={1} as="hint" color="textPrimary">
                  {startTimeExport
                    ? months[startTimeExport.getMonth()] +
                      " " +
                      startTimeExport.getDate() +
                      " "
                    : ""}
                </Text>
                <Text
                  numberOfLines={1}
                  as="hint"
                  weight="bold"
                  color="textPrimary"
                >
                  {startTimeExport
                    ? startTimeExport.getHours() +
                      ":" +
                      (startTimeExport.getMinutes() >= 10 ? "" : "0") +
                      startTimeExport.getMinutes()
                    : ""}
                </Text>
              </View>
              <View
                style={{
                  ...Helpers.rowCenter,
                  backgroundColor: Colors.lineDivider,
                  width: 81,
                  height: 24,
                  borderRadius: 8,
                }}
              >
                <Text numberOfLines={1} as="hint" color="textPrimary">
                  {stopTimeExport
                    ? months[stopTimeExport.getMonth()] +
                      " " +
                      stopTimeExport.getDate() +
                      " "
                    : ""}
                </Text>
                <Text
                  numberOfLines={1}
                  as="hint"
                  weight="bold"
                  color="textPrimary"
                >
                  {stopTimeExport
                    ? stopTimeExport.getHours() +
                      ":" +
                      (stopTimeExport.getMinutes() >= 10 ? "" : "0") +
                      stopTimeExport.getMinutes()
                    : ""}
                </Text>
              </View>
            </View>

            <View style={Helpers.colCenter}>
              <View style={{ width: previewWidth, height: previewHeight }}>
                <div style={{ display: "flex", width: "100%", height: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      width: previewWidth,
                      height: previewHeight,
                      ...Helpers.row,
                    }}
                  >
                    <ResponsiveLine
                      data={chartUpdated ? displayDataZoomed : []}
                      margin={{ top: 10, right: 10, bottom: 25, left: 10 }}
                      xScale={{
                        type: "time",
                        format: "native",
                        // precision: 'hour',
                      }}
                      yScale={{
                        type: "linear",
                        min: 0,
                        max: 1,
                        stacked: false,
                        reverse: false,
                      }}
                      gridYValues={[
                        0,
                        1 / 6,
                        (2 * 1) / 6,
                        (3 * 1) / 6,
                        (4 * 1) / 6,
                        (5 * 1) / 6,
                        1,
                      ]}
                      gridXValues={verticalLines}
                      yFormat=" >-.2f"
                      axisTop={null}
                      axisRight={null}
                      axisLeft={null}
                      axisBottom={null}
                      colors={(d) => d.color}
                      enablePoints={false}
                      enableSlices={false}
                      enableCrosshair={false}
                      onClick={(point, event) => {
                        console.log("Point:", point);
                        console.log("Event:", event);
                      }}
                      legends={[]}
                      motionConfig="gentle"
                      layers={[
                        "grid",
                        "markers",
                        "axes",
                        "areas",
                        "crosshair",
                        "lines",
                        "points",
                        "slices",
                        "mesh",
                        "legends",
                        CustomDashedLines,
                      ]}
                      animate={false}
                    ></ResponsiveLine>
                  </div>
                </div>
              </View>
              <Graph.XAxis
                xdata={xdataZoomed}
                yAxisEnabledCount={0}
                isLoading={false}
                axisWidth={0}
                width={previewWidth}
                horizontalContentInset={{ left: 0, right: 10 }}
                landscape={true}
                verticalLines={verticalLines}
                setVerticalLines={(lines) => (verticalLines = lines)}
              />
            </View>
            <Row.Section title="Time Frame" />
            <Row.Time
              title="Start"
              value={startTimeExport}
              icon={startIcon}
              timePickerVisible={startTimeExportPicker}
              datePickerVisible={startDateExportPicker}
              onPressTime={() => setStartTimeExportPicker(true)}
              onPressDate={() => setStartDateExportPicker(true)}
              onChangeTime={(value) => updateDateTime(value, true, true, true)}
              onChangeDate={(value) => updateDateTime(value, true, false, true)}
            />
            <Row.Time
              title="End"
              value={stopTimeExport}
              icon={endIcon}
              timePickerVisible={stopTimeExportPicker}
              datePickerVisible={stopDateExportPicker}
              onPressTime={() => setStopTimeExportPicker(true)}
              onPressDate={() => setStopDateExportPicker(true)}
              onChangeTime={(value) => updateDateTime(value, false, true, true)}
              onChangeDate={(value) =>
                updateDateTime(value, false, false, true)
              }
            />
            <Row.Section title="Format" />
            <Row.Picker //Format
              title="Format"
              icon={fileIcon}
              values={formatList}
              value={formatList[format]}
              setValue={(value) => {
                console.log("NEW VALUE:", value);
                console.log(
                  "Calculated index:",
                  formatList.findIndex((item) => item == value)
                );
                setFormat(formatList.findIndex((item) => item == value));
              }}
              onPress={(value) => {}}
            />
          </View>
          <View
            style={{
              ...Metrics.verticalPadding,
              ...Helpers.row,
              justifyContent: "space-around",
              width: "100%",
            }}
          >
            {format == 0 || format == 1 || format == 2 ? ( //CSV, Excel, or PDF
              <Button
                text="Export"
                style={{ width: "87%" }}
                variant="primary"
                isLoading={exportLoading}
                onPress={() => {
                  setExportLoading(true);
                  setExportInitiated(true);
                }}
              />
            ) : (
              <></>
            )}
          </View>
        </Modal>
      </Paper>
    </>
  );
}

export default Sites;